import { message } from "antd";
import { isValidMobileNo } from "./inventory.service";

/**
 * Finds the first duplicate string in an array.
 * A "first duplicate" means the first element that repeats
 * when scanning from left to right.
 *
 * @param {string[]} arr - Array of strings to search
 * @returns {string|null} - The first duplicate string, or null if none found
 */
export function findFirstDuplicateItem(arr=[]) {
  if (arr.length === 0) return;
  const seen = new Set();

  for (const item of arr) {
    const normalized = item.toLowerCase();

    // If we've already seen this normalized value, it's a duplicate
    if (seen.has(normalized)) {
      return item; // return the original (with case preserved)
    }

    seen.add(normalized);
  }

  return null;
}

export function validateSupplier(supplierName, mobileNo, address, ingredientNames=[]) {
  if (!supplierName || typeof supplierName !== "string" || supplierName.trim() === "") {
    message.warning(`Name can not be empty.`);
    return false;
  }
  if (!mobileNo || mobileNo.length < 1) {
    message.warning(`Please enter mobile no.`);
    return false;
  }
  if (!isValidMobileNo(mobileNo)) {
    message.warning(`Please enter a valid mobile no.`);
    return false;
  }
  if (!address || typeof address !== "string" || address.trim() === "") {
    message.warning(`Address can not be empty.`);
    return false;
  }
  if (address.length > 250) {
    message.warning("Address length excceds. Please make it short!");
    return false;
  }

  const duplicateItem = findFirstDuplicateItem(ingredientNames);
  if (duplicateItem) {
    message.warning(`Pleae remove duplicate item: ${duplicateItem}`);
    return false;
  }

  return true;
}

// export function getArrayOfStringItems(supplierItems) {
//   const ingredientNames = [];
//   if (supplierItems.length < 1) return;
//   supplierItems.map((item) => {
//     const { id, ...restItem } = item;
//     if (restItem.itemName === "") return;
//     ingredientNames.push(restItem.itemName);
//   });
//   return ingredientNames;
// }

export function prepareSupplierItems(supplierItems) {
  if (supplierItems.length < 1) return [];
  const items = [];
  supplierItems.map((item) => {
    items.push({
      id: crypto.randomUUID(),
      itemName: item,
    });
  });
  return items;
}

export const defaultSupplierItems = [
  {
    id: crypto.randomUUID(),
    itemName: "",
  },
];

export function prepareIngredientDropdowns(ingredients, onlyId = false) {
  if (ingredients.length < 1) return;
  return !onlyId
    ? ingredients.map((ingredient) => ({ value: ingredient.id, label: ingredient.name }))
    : [...ingredients.map((ingredient) => ingredient.id)];
}

export function getPreviouseSelectedIngredientsId(ingredients) {
  if (ingredients.length < 1) return;
  const selectedIngredients = ingredients.filter((item) => item.isSelected);
  return prepareIngredientDropdowns(selectedIngredients, true);
}
